import { useSelector } from 'react-redux';
import React from 'react';
import { useIntl } from 'react-intl';

import { magicStrings } from '../utils';
import { StoreList } from '../StoreList/StoreList';

import {
  cartStoreSelector,
  cartItemsSelector,
} from '../../../redux/selectors/cartSelectors';
import ConflictingStoreMessage from '../../CartComponents/ConflictingStoreMessage/ConflictingStoreMessage';
import useActiveStore from '../../../hooks/useActiveStore';
import { NearbyStore, StoreLogo } from '../../../types';
import { useFeatureFlag } from '../../FeatureFlag/useFeatureFlag';
import { FeatureFlags } from '../../FeatureFlag/featureFlags';
import { StoreSelector, Search } from './styles';

interface Props {
  nearbyStores: NearbyStore[];
  allStoreLogos: StoreLogo[];
  setInputRef: (instance: HTMLInputElement | null) => void;
  scrollToTop?: () => void;
}

export const NearbyStores = ({
  nearbyStores,
  allStoreLogos,
  setInputRef,
  scrollToTop = () => null,
}: Props) => {
  const { locale } = useIntl();
  // TODO Rename the selector and reducer
  // Since its not a cart specific store but instead a global store, it should be in a global redux state instead of cart
  const cartStoreData = useSelector(cartStoreSelector);
  const cartData = useSelector(cartItemsSelector);
  const { activeStore, setActiveStore } = useActiveStore();

  const isReserveAccessoriesFFEnabled = useFeatureFlag(FeatureFlags.ReserveAccessories);

  return (
    <StoreSelector>
      <h3>{magicStrings.getStoreSelectorTitle(locale)}</h3>
      {isReserveAccessoriesFFEnabled
        && !!cartData.length && cartStoreData.selectedStoreChanged && (
        <ConflictingStoreMessage />
      )}

      <Search
        type="text"
        id="google-geocode-autocomplete"
        name="google-geocode-autocomplete"
        aria-label={magicStrings.getPlaceHolder(locale)}
        placeholder={magicStrings.getPlaceHolder(locale)}
        ref={setInputRef}
      />
      <StoreList
        allStoreLogos={allStoreLogos}
        nearbyStores={nearbyStores}
        activeStore={activeStore}
        onClick={(store) => {
          scrollToTop();
          setActiveStore(store);
          window.sessionStorage.setItem('activeStore', JSON.stringify(store));
        }}
      />
    </StoreSelector>
  );
};
